import { render, staticRenderFns } from "./ShopContainer.vue?vue&type=template&id=697bc89c&"
import script from "./ShopContainer.vue?vue&type=script&lang=js&"
export * from "./ShopContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports